import React, { useEffect, useState } from "react";
import Poya from "./assets/Poya.png"
import styled from "styled-components";
import calendar from "./assets/calendar-page.jpg";
import coin from "./assets/pexels-stories.jpg";
import "./css/DynamicPricePage.css"

const Title = styled.h2`
    font-family: dana-bold;
  display:block;
  text-align:center;
  font-size: 35px;
  margin-top:10px;
`;

const Text = styled.p`
    font-size: 18px;
    margin-top: 20px;
    color: #525256;  
    text-align:center;  
`;

const Content = styled.div`
    font-size: 18px;
    margin-top: 20px;
    display:block;
    padding:30px 40px;
    border-radius:20px;
    display:flex;
    justify-content:center;
`;

const Button = styled.button`
  background-color: #3DC36D;
  border-radius: 20px;
  width: 140px;
  padding: 10px;
  border: none;
  color: white;
`;

const Map = styled.img`
  width: 100%;
`;

const Bold = styled.b`
    font-weight:bold;
    padding-bottom:0;
    display:inline;
`;


const Card = styled.div`
    background-color: white;
    border-radius: 20px;
`;

const ImgCard = styled.img`
    width:100%;
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
    object-fit: cover
`;

const ImgCardLeft = styled.img`
    width:100%;
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
    object-fit: cover
`;

const ContentCard = styled.div`
    
`;

const TitleCard = styled.div`
font-family: dana-bold;
    font-size:25px;
    padding-top:20px;
    padding-right:20px
`;

const TextCard = styled.p`
    font-size:18px;
    padding:20px
`;

const PoyaPrice = styled.div`
    font-size:18px;
    background-color:white;
    display:flex;
    justify-content:center;
`;

const Link = styled.a`
    outline:none;
    color:white
`;

function DynamicPricePage(){
    return(<>
        <div className="container col-12 px-0 mx-0">
            <PoyaPrice className='row '>
                <div className="mt-10 col-12 col-md-10 px-xl-40">
                    <Title style={{fontSize:"30px !important"}} >قیمت گذاری پویا</Title>
                </div>
                <Map src={Poya} className="p-5 p-lg-10 col-12 col-md-8 px-xl-40" />
                
                <Text className="col-11 col-md-12 col-lg-10 px-md-25 px-xl-40 pb-10">این روزها احتمالا شما هم با افزایش قیمت بلیط اتوبوس بین شهری مواجه بوده‎اید ...
                    تو این شرایط ممکنه با خودتون فکر کنید که اگه با ماشین شخصی ، قطار یا وسیله نقلیه عمومی دیگه ای سفر کنید، تو هزینه ها صرفه‎جویی کرده ‎ اید.
                    <Bold> همراه ما باشید تا از رازِ پُشت پرده قیمت گذاری بلیط اتوبوس ایباس رو با شما به اشتراک بگذاریم.</Bold>
                </Text>
            </PoyaPrice>
        </div>

        <div className="container">
            <div className='row d-flex justify-content-center'>
                <Text className="mt-17 col-12 col-lg-10 col-md-11 px-xl-40 py-25">
                با در نظر گرفتن فاکتورهای مهمی مثل :<Bold>
                هزینه سفر، راحتی در حمل و نقل، ایمنی و دسترسی</Bold> در حال حاضر ایباس برای جابه ‎جایی بین شهری با اتوبوس گزینه مناسب تریه،
                چرا که<br /><br />
                <Bold> قیمت بلیط اتوبوس در ایباس، دچار افزایش نشده</Bold>.
                </Text>
                
                <Card className="row col-12 col-xl-10 pl-0 mb-15">
                    <ImgCard 
                        src={calendar}
                        className="col-3 col-md-4 col-lg-3 px-0"
                    />
                    <ContentCard className="col-9 col-md-8 col-lg-9">
                        <TitleCard>خرید بلیط زودهنگام</TitleCard>
                        <TextCard>
                        خرید  و رزرو<Bold> بلیط زودهنگام</Bold>  به  صرفه ترین سفر رو با ایباس تجربه کنید. #همیشه_به_سفر
                        تاریخی رو، روی تقویم تصور کنید ... که به دلیل تعطیلی فرصت خوبی رو پیش روی شما گذاشته که سفر کنید.
                         اگه از اون دسته افرادی باشید که  برنامه ریزی قبل از سفر براتون از اهمیت بالایی برخورداره، خرید به صرفه بلیط سفرتون هم می تونه براتون الویت باشه. چه خوب که زودتر از موعد سفر بتونیم بلیط کم هزینه تری برای سفر اتوبوسی مون داشته باشیم و این امکان رو تو همه گرونی ها و اوضاع بد اقتصادی ما تو ایباس به شما میدیم.

                        </TextCard>
                    </ContentCard>
                </Card>

                <Card className="row col-12 col-xl-10 pr-0 mb-15" style={{direction:"ltr"}}>
                    <ImgCardLeft 
                        src={coin}
                        className="col-3 col-md-4 col-lg-3 px-0"
                    />
                    <ContentCard className="col-9 col-md-8 col-lg-9">
                        <TitleCard>فرصت اولین بودن رو از دست نده</TitleCard>
                        <TextCard>
                        تو خرید بلیط اتوبوس از ایباس نفرات اول با پایین ترین قیمت بلیط اتوبوس خودش رو می تونه خریداری کنه.
                        و افراد دیگر به ترتیب با قیمت پیشنهادی بالاتری تا سقف قیمتی تعیین شده می تونن بلیط اتوبوس خودشون رو تهیه کنند. اما در مقایسه قیمت بلیط اتوبوس ایباس با شرکت های دیگه، حتی اگه بلیط سفرتون رو لحظه آخر ( به شرط موجود بودن بلیط )  خریداری کنید از سقف قیمت تعیین شده هم پایین تر خواهد بود.

                        </TextCard>
                    </ContentCard>
                </Card>

                <Content className="bg-white col-12 col-xl-10 row mb-15">
                    <TextCard className="col-12" style={{textAlign:"center"}}>
                        برای خرید بلیط اتوبوس ایباس
                    همین الان برنامه سفرت رو بچین
                    قیمت ها رو مقایسه کن 
                    و بلیط سفر تاریخ حرکت و برگشت رو از ایباس خریداری کن.
                    </TextCard>
                    <Button className="col-12 col-md-4">
                        <Link href="http://ebus.ir">جستجوی بلیط</Link> 
                    </Button>
                </Content>
            </div> 
        </div>
        </>
    )
}

export default DynamicPricePage